export default __webpack_public_path__ + "static/media/astro-bg-mobile.9da78bb4.png";